import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { DonutChartComponent } from './donut-chart.component';


@NgModule({
  imports: [
    CommonModule,
    RoundProgressModule,
  ],
  declarations: [DonutChartComponent],
  exports:[DonutChartComponent],
})
export class DonutChartModule { }
